import { z } from 'zod';
import { type Tasks } from '../../../workflow/schemaTypes';

export type ResolutionData = Record<
  Extract<Tasks, 'resolution'>,
  {
    resolutionId?: string;
    // Server-authored title carried from the selection card so the collapsed
    // step summary resolves the same text without access to the options query.
    title?: string;
    exchangeItem?: {
      productId: string;
      variantId: string;
    };
  }
>;

export const ResolutionTaskSchema = z.object({
  resolutionId: z
    .string({
      error: (issue) =>
        issue.input === undefined ? 'Selection required' : 'Selection required',
    })
    .min(1),
  title: z.string().optional(),
  exchangeItem: z
    .object({
      productId: z.string().min(1),
      variantId: z.string().min(1),
    })
    .optional(),
});
